import { render, staticRenderFns } from "./detailAddress.vue?vue&type=template&id=51ae78c9&scoped=true&"
import script from "./detailAddress.vue?vue&type=script&lang=ts&"
export * from "./detailAddress.vue?vue&type=script&lang=ts&"
import style0 from "./detailAddress.vue?vue&type=style&index=0&id=51ae78c9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ae78c9",
  null
  
)

export default component.exports